import React, { memo, useState, forwardRef, useImperativeHandle } from 'react';
import { Colors } from 'modules/theme';
import { DropdownMenu, Button, Icon } from 'modules/ui';

// eslint-disable-next-line react/display-name
const DropdownButton = forwardRef((props, ref) => {
  const {
    children,
    iconName = 'moreHorizontal',
    iconColor = Colors.white,
    vertical,
    header,
    dropdownWidth,
    arrowRightPosition,
    buttonStyle,
    buttonClassName,
    label,
    iconSize = 16,
    iconStyle,
    ...otherProps
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  function handleOnClick(event) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }

  function handleClose(event) {
    if (event) {
      event.stopPropagation();
    }

    setAnchorEl(null);
  }

  useImperativeHandle(ref, () => ({ close: handleClose }));

  const resolvedArrowPosition = arrowRightPosition || '20px';
  const resolvedButtonStyles = {
    ...buttonStyle,
    ...(vertical && {
      transform: 'rotate(90deg)',
    }),
    ...(header && {
      alignSelf: 'center',
      minWidth: 40,
      height: 40,
      marginLeft: 16,
      backgroundColor: Colors.darkGrey,
    }),
  };

  return (
    <>
      <Button
        small
        onClick={handleOnClick}
        className={buttonClassName}
        style={resolvedButtonStyles}
        {...otherProps}
      >
        {label}
        <Icon
          style={iconStyle}
          name={iconName}
          color={iconColor}
          size={iconSize}
        />
      </Button>
      <DropdownMenu
        onClick={handleClose}
        onClose={handleClose}
        width={dropdownWidth}
        open={!!anchorEl}
        anchorEl={anchorEl}
        arrowRightPosition={resolvedArrowPosition}
      >
        {children}
      </DropdownMenu>
    </>
  );
});

export default memo(DropdownButton);
